import React from 'react';

// "Built for every stage of your journey and every side of the deal" — who-it's-for section.
const IconHome = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4A67FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>;
const IconBriefcase = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#E8820C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>;
const IconTrend = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;

const anthony = require('../../../../images/landing-pages/home-page/anthony.jpg');
const mojee = require('../../../../images/landing-pages/home-page/mojee_wilson.jpg');
const paul = require('../../../../images/landing-pages/home-page/paul_morris.png');
const neil = require('../../../../images/landing-pages/home-page/foster_neil.jpg');
const kevin = require('../../../../images/landing-pages/home-page/kevin.jpg');

const QuoteBar = ({ quote, name, role, img, alt }) => (
    <div className="lp-who-quotebar" data-lp-reveal>
        <div className="lp-who-quotebar-c">
            <div className="lp-who-mark">&ldquo;</div>
            <blockquote>{quote}</blockquote>
            <p className="w100 nm">{name}</p>
            <p className="w100 rl">{role}</p>
        </div>
        <div className="lp-who-quotebar-img"><img src={img} alt={alt} /></div>
    </div>
);

const PersonaRow = ({ reverse, Icon, iconClass, title, desc, img, alt, quote, name, role }) => (
    <div className={`lp-who-row ${reverse ? 'is-reverse' : ''}`} data-lp-reveal>
        <div className="lp-who-copy">
            <div className={`lp-who-ic ${iconClass}`}><Icon /></div>
            <h3>{title}</h3>
            <p>{desc}</p>
        </div>
        <div className="lp-who-media">
            <div className="lp-who-photo"><img src={img} alt={alt} /></div>
            <div className="lp-who-float">
                <div className="lp-who-mark sm">&ldquo;</div>
                <blockquote>{quote}</blockquote>
                <p className="nm">{name}</p>
                <p className="rl">{role}</p>
            </div>
        </div>
    </div>
);

const HomeWhoItsFor = () => (
    <section className="lp-who">
        <div className="lp-who-head">
            <div className="lp-badge lp-badge--up lp-who-eyebrow" data-lp-reveal><span />Hear from those who know</div>
            <h2 className="lp-h2" data-lp-reveal data-lp-delay="60">Tools built for every stage of your journey and<br />every side of the deal</h2>
        </div>

        <div className="lp-who-inner">
            <QuoteBar
                quote="The problem is, with VCs, you write to them, they never reply. So, what if there was somebody who would help you get connected with VCs? That's where Diligentsia comes in."
                name="Anthony Rose" role="Founder, Seedlegals" img={anthony} alt="Anthony Rose"
            />

            <PersonaRow
                Icon={IconHome} iconClass="lp-who-ic--blue" title="Companies."
                desc="Get transaction ready. Create diligence pack. Funding? 1-click connect to 50+ VCs."
                img={mojee} alt="Mojee Wilson"
                quote="It's brilliant, I could not recommend it enough! ...the platform works like a dream."
                name="Mojee Wilson" role="Founder, Saat.WS"
            />

            <QuoteBar
                quote="In my experience, not being prepared and a lack of data integrity can lead to price chipping, but actually more often causes deals to fail. Anything you can do to reduce this is immensely valuable."
                name="Paul Morris" role="Ex Head of Growth Advisory, BDO" img={paul} alt="Paul Morris"
            />

            <PersonaRow
                reverse Icon={IconBriefcase} iconClass="lp-who-ic--amber" title="Advisors."
                desc="Free tools to increase margins on existing services. New services. New client introductions."
                img={neil} alt="Neil Foster"
                quote="I do 100 VC deals each year. Getting prepared for transactions is boring, but critical. You will get more term sheets and deals will close more quickly."
                name="Neil Foster" role="Senior Partner, Brown Rudnick LLP"
            />

            <PersonaRow
                Icon={IconTrend} iconClass="lp-who-ic--green" title="Investors & Purchasers."
                desc="Free application triaging in 3 minutes. Qualified, diligenced deal flow. AI Diligence tools."
                img={kevin} alt="Kevin Jackson"
                quote="We want to monitor, add value and support our cohorts from first application to exit. Diligentsia helps us do this."
                name="Kevin Jackson" role="Co-founder & Chairman, AI Forge"
            />
        </div>
    </section>
);

export default HomeWhoItsFor;
